import { useTick } from './useTick';

export interface NumProps {
  value: number;
  decimals?: number;
  suffix?: string;
  animate?: boolean;
  className?: string;
}

export function Num({ value, decimals = 0, suffix, animate = true, className }: NumProps) {
  const shown = useTick(value, animate);
  const text = shown.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return (
    <span className={className}>
      <span className="font-mono tabular-nums">{text}</span>
      {suffix ? <span className="ml-1 text-[0.6em] text-muted">{suffix}</span> : null}
    </span>
  );
}
